export const Template = {
    path: '/templates',
    name: 'templates',
    component: () => import('@/views/Edms/Template/TemplatePage.vue'),
    children: [
        {
            path: '/templates/add',
            name: 'templates.add',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { addAction: true }
        },
        {
            path: '/templates/edit/:id',
            name: 'templates.edit',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { updateAction: true }
        },
        {
            path: '/templates/delete/:id',
            name: 'templates.delete',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { deleteAction: true }
        },
        {
            path: '/templates/view/:id',
            name: 'templates.view',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { viewAction: true }
        },
        {
            path: '/templates/archive/:id',
            name: 'templates.archive',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { archiveAction: true }
        },
        {
            path: '/templates/unarchive/:id',
            name: 'templates.unarchive',
            component: () => import('@/views/Edms/Template/Form/TemplateForm.vue'),
            props: { unarchiveAction: true }
        },
    ],
}
